/*  JS to block the checkout buttons
    Added by Wilson from Galadrim  */

// Disable checkout button on cart page if any item exceeds stock
// Updated function to control sidebar checkout button state
function updateCartPageCheckoutButton() {
  const checkoutBtn = document.getElementById("sidebar-checkout-button"); // Target by ID
  const allocationMessageEl = document.getElementById("sidebar-allocation-message");
  const b2bBlockedMessageEl = document.getElementById("sidebar-b2b-blocked-message");
  const nonB2bMessageEl = document.getElementById("sidebar-non-b2b-message");
  const guestMessageEl = document.getElementById("sidebar-guest-message");
  const lowAmountMessageEl = document.getElementById("sidebar-low-amount-message");

  if (!checkoutBtn) {
    return;
  }

  let disableButton = false;
  let messageToShow = null; // 'allocation', 'b2b', 'non-b2b', or null

  // 1. Check for overStock (existing logic)
  let overStock = false;
  document.querySelectorAll(".cart-item .quantity-selector__input[data-inventory-quantity]").forEach(input => {
    const stock = parseInt(input.getAttribute("data-inventory-quantity"), 10);
    const value = parseInt(input.value, 10) || 1;
    if (!isNaN(stock) && value > stock) {
      overStock = true;
    }
  });

  if (overStock) {
    disableButton = true;
  }

  // 2. Check for allocated items
  const hasAllocatedItems = document.querySelector(".allocated-products-section").style.display !== "none";

  if (hasAllocatedItems) {
    disableButton = true;
    messageToShow = "allocation";
  }

  // 3. Check for B2B blocking (e.g., unpaid invoice)
  const unpaidInvoiceAlert = document.querySelector(".alert-unpaid-invoice");
  const isB2BBlockedByInvoice =
    unpaidInvoiceAlert &&
    unpaidInvoiceAlert
      .querySelector(".alert-unpaid-invoice__title")
      ?.textContent.includes("FACTURE EN ATTENTE DE PAIEMENT");
  const isB2BBlockedBySidebar = b2bBlockedMessageEl && b2bBlockedMessageEl.style.display !== "none";

  if (isB2BBlockedByInvoice || isB2BBlockedBySidebar) {
    disableButton = true;
    if (messageToShow !== "allocation") {
      // Allocation message takes precedence
      messageToShow = "b2b";
    }
  }

  // 4. Check for non-B2B customer
  if (nonB2bMessageEl && nonB2bMessageEl.style.display !== "none") {
    disableButton = true;
    if (messageToShow !== "allocation" && messageToShow !== "b2b") {
      messageToShow = "non-b2b";
    }
  }

  // 5. Check for guest user
  if (guestMessageEl && guestMessageEl.style.display !== "none") {
    disableButton = true;
    if (messageToShow !== "allocation" && messageToShow !== "b2b" && messageToShow !== "non-b2b") {
      messageToShow = "guest";
    }
  }

  // 6. Check for too low cart amount
  if (lowAmountMessageEl) {
    disableButton = true;
  }

  // 7. Check CGV acceptance
  // Si la checkbox est présente (needs_accept) et pas cochée → on bloque
  const cgvCheckbox = document.getElementById("cgv-accept-checkbox");
  const cgvRequiredElement = document.querySelector(".cart-terms");
  if (cgvRequiredElement && (!cgvCheckbox || !cgvCheckbox.checked)) {
    disableButton = true;
    // Vous n’avez pas de message spécifique donc on ne change pas messageToShow
  }

  // 8. Si la commande a plus de 99 lignes
  if (Shopify.cart.items.length > 99) {
    disableButton = true;
  }

  // Apply state to button
  if (disableButton) {
    checkoutBtn.setAttribute("disabled", "disabled");
    checkoutBtn.classList.add("checkout-button--js-disabled");
  } else {
    checkoutBtn.removeAttribute("disabled");
    checkoutBtn.classList.remove("checkout-button--js-disabled");
    // checkoutBtn.style.pointerEvents = '';
    // checkoutBtn.style.opacity = '';
  }

  // Show/hide messages
  if (allocationMessageEl) {
    allocationMessageEl.style.display = messageToShow === "allocation" ? "block" : "none";
  }
  if (b2bBlockedMessageEl) {
    b2bBlockedMessageEl.style.display = messageToShow === "b2b" ? "block" : "none";
  }
  if (nonB2bMessageEl) {
    nonB2bMessageEl.style.display = messageToShow === "non-b2b" ? "block" : "none";
  }
  if (guestMessageEl) {
    guestMessageEl.style.display = messageToShow === "guest" ? "block" : "none";
  }
}

// --- Event Listeners & State Management ---

const CGV_STORAGE_KEY = "cgv_accepted_state";

// This is the core function that runs after any potential cart change.
// It restores the CGV state from memory and then re-validates the checkout button.
function syncUIState() {
  const cgvCheckbox = document.getElementById("cgv-accept-checkbox");
  if (cgvCheckbox) {
    try {
      if (localStorage.getItem(CGV_STORAGE_KEY) === "true") {
        cgvCheckbox.checked = true;
      }
    } catch (e) {
      console.error("Erreur lecture CGV localStorage:", e);
    }
  }
  // Now that the state is potentially restored, update the button.
  updateCartPageCheckoutButton();
}

// Listen for direct user interactions
document.addEventListener(
  "change",
  function (e) {
    const target = e.target;
    if (target.id === "cgv-accept-checkbox") {
      try {
        localStorage.setItem(CGV_STORAGE_KEY, target.checked);
      } catch (e) {
        console.error("Erreur stockage CGV localStorage:", e);
      }
      updateCartPageCheckoutButton();
    } else if (target.matches(".quantity-selector__input[data-inventory-quantity]")) {
      updateCartPageCheckoutButton();
    }
  },
  true
);

document.addEventListener(
  "input",
  function (e) {
    if (e.target.matches(".quantity-selector__input[data-inventory-quantity]")) {
      updateCartPageCheckoutButton();
    }
  },
  true
);

// This is the key for reacting to AJAX updates from the theme.
document.addEventListener("DOMContentLoaded", () => {
  // Run once on initial load.
  syncUIState();

  // The theme replaces the contents of this container after an AJAX cart update.
  // We watch it for changes.
  const cartContainer = document.querySelector(".cartitems--container");

  if (cartContainer) {
    const observer = new MutationObserver(mutationsList => {
      // The cart's content has been changed.
      // Now we can safely sync the UI state.
      syncUIState();
    });

    // Start observing the cart container for when its child elements are added or removed.
    observer.observe(cartContainer, { childList: true, subtree: true });
  }
});
